import ApiIcon from '@mui/icons-material/Api';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { Button, Card, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import HttpServices from 'src/services/httpService';
import { userModuleURL } from 'src/services/urlService';
import { CommonHelper } from 'src/utils/commonHelper';
import { useToaster } from 'src/utils/toaster/toasterContext';
import OrgManageBrand from '../organizationBrand';

const ResellerComponent = () => {
  const { t: translate } = useTranslation();
  const isReseller = CommonHelper.GetBrandInfoFromLocalStorage('is_reseller');
  const { showToast } = useToaster();
  const isCustomDomain = CommonHelper.CustomDomain();
  const isPortalAdmin = CommonHelper.GetBrandInfoFromLocalStorage('is_portal_admin');
  const [isResellerEnabled, setResellerEnabled] = useState(isReseller);

  const [showWarningDialog, setShowWarningDialog] = useState(false);

  const handleEnableReseller = () => {
    const postProps = {
      url: userModuleURL.enableReseller,
      successCallback: (data, message) => {
        setResellerEnabled(true);
        showToast(message || translate('reseller.enable_success'), 's');
        setShowWarningDialog(false);
        window.location.reload();
      },
      failureCallback: (message) => {
        showToast(message || translate('reseller.enable_failed'), 'e');
      },
    };
    HttpServices.Post(postProps);
  };

  if (isResellerEnabled) {
    return <OrgManageBrand />;
  }

  return (
    <>
      {/* Main Card */}
      <Card
        sx={{
          height: 'calc(100vh - 160px)',
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 2,
        }}
      >
        <ApiIcon sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1, color: 'primary.main', textAlign: 'center' }}>
          {translate('reseller.access_required')}
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary', textAlign: 'center', maxWidth: 380 }}>
          {translate('reseller.access_not_enabled_new')}
        </Typography>
        {(!isCustomDomain || isPortalAdmin) && (
          <Button
            variant="outlined"
            startIcon={<YouTubeIcon />}
            onClick={() => window.open('https://www.youtube.com/watch?v=8-vBuBgzAXM', '_blank')}
            color="primary"
            sx={{ mb: 3 }}
          >
            {translate('common.tutorial')}
          </Button>
        )}
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => setShowWarningDialog(true)}
          sx={{ fontWeight: 600, borderRadius: 1, minWidth: 200 }}
        >
          {translate('reseller.enable_access')}
        </Button>
      </Card>

      {/* Warning Dialog */}
      <Dialog open={showWarningDialog} onClose={() => setShowWarningDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ textAlign: 'center', fontWeight: 700, color: 'warning.main' }}>
          <ApiIcon sx={{ fontSize: 36, color: 'warning.main', mb: 1 }} />
          <div>{translate('reseller.warning_title')}</div>
        </DialogTitle>
        <DialogContent sx={{ textAlign: 'center', pb: 2 }}>
          <Typography variant="body1" sx={{ mb: 2, fontWeight: 500 }}>
            {translate('reseller.warning_message')}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
          <Button
            onClick={() => setShowWarningDialog(false)}
            variant="outlined"
            color="inherit"
            sx={{ minWidth: 100, fontWeight: 600 }}
          >
            {translate('common.cancel')}
          </Button>
          <Button
            onClick={handleEnableReseller}
            variant="contained"
            color="warning"
            sx={{ minWidth: 140, fontWeight: 700 }}
          >
            {translate('reseller.i_understand')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ResellerComponent;
